export enum CurrentComponentEnum {
    Progress = 'progress',
    Login = 'login',
    PasscodeLogin = 'passcodeLogin',
    Launch = 'launch',
    Session = 'session',
    Error =  'error'
}